import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbDateParserFormatter, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateItParserFormatter} from '../../../component/date-custom/ngb-date-it-parser-formatter';
import {CustomDatepickerI18n, I18n} from '../../../component/date-custom/ng-bootstrap-datepicker-i18n';
import {Subject} from 'rxjs/Subject';
import {BsModalRef} from 'ngx-bootstrap';
import {GareService} from "../gare.service";
import {MapsAPILoader} from "@agm/core";
import {Observable} from "rxjs";
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from "rxjs/operators";
import * as _ from "lodash";
import {ListItemModel} from "../../../component/select-custom/list.item.model";
import {of} from "rxjs/observable/of";
import {TesseramentoService} from "../../tesseramento/tesseramento.service";
import {EventiService} from "../../eventi/eventi.service";

let allDisciplines: any[] = [];

@Component({
  selector: 'app-crea-gara',
  templateUrl: './crea.component.html',
  providers: [
    I18n,
    {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
    {provide: NgbDateParserFormatter, useClass: NgbDateItParserFormatter}
  ] // define custom NgbDatepickerI18n provider
})

export class CreaGaraComponent implements OnInit {

  @ViewChild('googleLocation')
  public searchElementRef: ElementRef;

  regularForm: FormGroup;

  eventId: number;
  allDisciplines: any[];
  allConiDisciplines: any[];
  levels: any[];
  googleLocationUsed: boolean;

  public onClose: Subject<any>;

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? []
        : allDisciplines.filter(v => v.description.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  searchCountry = (text$: Observable<ListItemModel>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => { ; }),
      switchMap(term =>
        this.tesseramentoService.getAutocompleteCityForeign(term).pipe(
          tap(() => { ; }),
          catchError(() => {

            return of([]);
          }))
      ),
      tap(() => { ; })
    );

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    private gareService: GareService,
    private eventiService: EventiService,
    private tesseramentoService: TesseramentoService
  ) {
  }

  ngOnInit() {
    this.onClose = new Subject();
    this.inizializeForm();
    setTimeout(() => {
      this.inizializeMaps();
    }, 500);
    this.allConiDisciplines = _.filter(this.allDisciplines, (o) => {return o.code != null})
    allDisciplines = this.allConiDisciplines;
  }

  formatter = (x: {description: string}) => x.description;

  private inizializeForm() {
    this.regularForm = this.fb.group({
      title: [null, Validators.required],
      startDate: [null, Validators.required],
      discipline: [null, [Validators.required]],

      level: this.fb.group({
        id: [null, [Validators.required]],
      }),
      isAbroad: [false],
      country: [null],
      toAbroad: [null],
      googleLocation: [null],
      location: this.fb.group({
        address: [null],
        streetNumber: [null],
        province: [null],
        city: [null],
        zipcode: [null],
        to: [null],
      }),
      fase: [null],
      turno: [null],
      girone: [null],
      giornata: [null],
    }, {updateOn: 'blur'});


    this.regularForm.get('isAbroad').valueChanges.subscribe((value) => {
      if(!value) {
        // if (!this.googleLocationUsed) {
          setTimeout(() => {
            this.inizializeMaps();
          }, 500);
          this.regularForm.get('googleLocation').setValue(null);
          this.regularForm.get('country').setValue(null);
          this.googleLocationUsed = false;
        }
      // }
    });
  }

  private inizializeMaps() {
    this.mapsAPILoader.load().then(() => {
      const autocompleteSedeOperativa = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {types: ['address']});
      autocompleteSedeOperativa.setComponentRestrictions({country: ['it']});
      autocompleteSedeOperativa.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocompleteSedeOperativa.getPlace();

          const res: any = {}
          res.address = this.getPlaceFieldAndError(place).address;
          // res.errors = this.getPlaceFieldAndError(place).errors;

          const form = this.regularForm.get('location');

          if (res.errors) {
            // form.get('operationalHeadquarters').setErrors({missing: true});
          }
          this.setAndCheckAddressField(form, res.address);
          this.googleLocationUsed = true;
        });
      });
    });
  }

  private getPlaceFieldAndError(place: any) {
    const res: any = {};
    res.address = {}
    res.errors = 4;
    for (const element of place.address_components) {
      if (element.types[0] === 'street_number') {
        res.address.streetNumber = element.short_name;
        // res.errors -= 1;
      } else if (element.types[0] === 'route') {
        res.address.address = element.short_name;
        res.errors--;
      } else if (element.types[0] === 'postal_code') {
        res.address.zipcode = element.short_name;
        res.errors--;
      } else if (element.types[0] === 'administrative_area_level_2') {
        res.address.province = element.short_name;
        res.errors--;
      } else if (element.types[0] === 'locality') {
        res.address.city = element.short_name;
        res.errors--;
      }
    }
    return res;
  }

  private setAndCheckAddressField(form: AbstractControl, values: any) {
    form.get('streetNumber').patchValue(values['streetNumber']);
    form.get('streetNumber').markAsTouched();
    form.get('province').patchValue(values['province']);
    form.get('province').markAsTouched();
    form.get('address').patchValue(values['address']);
    form.get('address').markAsTouched();
    form.get('zipcode').patchValue(values['zipcode']);
    form.get('zipcode').markAsTouched();
    form.get('city').patchValue(values['city']);
    form.get('city').markAsTouched();
  }

  creaGara() {
    const request = this.regularForm.getRawValue();
    request.startDate = NgbDateItParserFormatter.format(request.startDate);

    this.eventiService.createCompetition(this.eventId, request).subscribe(res => {
      this.onClose.next(res);
      this.bsModalRef.hide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/gare/crea/crea.component.ts